// src/utils/navigationDataPrefetch.js
// English:
// Background data warmup for likely-next navigation targets.
// Keep this silent and non-blocking.

import { getMyProfileCached, getPublicProfileByUsernameCached } from "../api/profileAPI";
import { warmTopicNavigation } from "../api/topicAPI";
import {
  prefetchAddTopicNavigation,
  prefetchProfileNavigation,
  prefetchTopicNavigation,
} from "./navigationPrefetch";

function runInIdle(job, timeout = 1000) {
  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(() => {
      Promise.resolve().then(job).catch(() => {});
    }, { timeout });
    return;
  }

  window.setTimeout(() => {
    Promise.resolve().then(job).catch(() => {});
  }, 120);
}

export function prefetchOwnProfileBundle(user = null) {
  prefetchProfileNavigation(user);

  runInIdle(async () => {
    await getMyProfileCached();
  });
}

export function prefetchPublicProfileBundle(username = "") {
  const clean = String(username || "").trim();
  if (!clean) return;

  prefetchProfileNavigation(null);

  runInIdle(async () => {
    await getPublicProfileByUsernameCached(clean);
  });
}

export function prefetchTopicBundle(topicOrWord) {
  prefetchTopicNavigation();

  runInIdle(async () => {
    await warmTopicNavigation(topicOrWord);
  });
}

export function prefetchAddTopicBundle() {
  prefetchAddTopicNavigation();
}